import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { FAQItem } from '../types';

interface FAQSectionProps {
  faqs: FAQItem[];
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="space-y-4">
      {faqs.map((faq) => (
        <div
          key={faq.id}
          className="bg-card rounded-lg border border-border overflow-hidden transition-shadow duration-fast hover:shadow-md"
        >
          <button
            onClick={() => toggleFAQ(faq.id)}
            className="w-full flex items-center justify-between p-6 text-left hover:bg-surface/50 transition-colors duration-fast"
          >
            <span className="font-semibold text-text-primary pr-4">{faq.question}</span>
            <Icon
              name="ChevronDown"
              size={20}
              className={`text-text-secondary flex-shrink-0 transition-transform duration-fast ${
                expandedId === faq.id ? 'rotate-180' : ''
              }`}
            />
          </button>
          {expandedId === faq.id && (
            <div className="px-6 pb-6 text-text-secondary leading-relaxed animate-fade-in">
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;